import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";

import bg_image from "../../assets/images/bg_image.svg";
import loginHealthsyImg from "../../assets/images/login_healthsy_img.webp";
import "./account.scss";

const Login = () => {
  const navigate = useNavigate();

  const [loginBtnBg, setLoginBtnBg] = useState("#FAE8EF");
  const [showPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [nameError, setNameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [rememberMe, setRememberMe] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("authToken")) {
      navigate("/");
    } else {
      navigate("/login");
    }
  }, [navigate]);

  useEffect(() => {
    const cookieUser = JSON.parse(localStorage.getItem("CookieUser"));
    const cookiePass = JSON.parse(localStorage.getItem("CookiePassword"));
    if (cookieUser) setUsername(cookieUser);
    if (cookiePass) setPassword(cookiePass);
  }, []);

  useEffect(() => {
    if (username && password) {
      setLoginBtnBg("#CB1B5B");
    } else {
      setLoginBtnBg("#FAE8EF");
    }
  }, [username, password]);

  const handleLogin = async () => {
    setError("");
    setNameError("");
    setPasswordError("");

    if (!username) {
      setNameError("Please provide a user name");
      return;
    }
    if (!password) {
      setPasswordError("Please provide a password");
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}admin-panel/login`,
        { username, password }
      );

      const { token } = response.data;

      if (token) {
        localStorage.setItem("authToken", token);

        if (rememberMe) {
          localStorage.setItem("CookieUser", JSON.stringify(username));
          localStorage.setItem("CookiePassword", JSON.stringify(password));
        } else {
          localStorage.removeItem("CookieUser");
          localStorage.removeItem("CookiePassword");
        }

        navigate("/");
        window.location.reload();
      } else {
        setError("Invalid credentials");
      }
    } catch (err) {
      setError("Login failed. Please check credentials.");
    }
  };

  const onChangeInput = (e, type) => {
    if (type === "username") {
      setUsername(e.target.value);
    } else {
      setPassword(e.target.value);
    }
  };

  const handleRememberMe = (e) => {
    setRememberMe(e.target.checked);
  };

  return (
    <div className="adminpanellogin">
      <div className="adminpanel-left">
        <div className="position-absolute adminpanel-login-image">
          <img className="adminpanel-login-img" src={bg_image} alt="" />
          <div className="position-absolute">
            <img
              className="adminpanel-login-healthsyImg"
              src={loginHealthsyImg}
              alt=""
            />
          </div>
        </div>
        <div className="adminpanel-left-box position-relative"></div>
      </div>

      <div className="adminpanel-right">
        <div className="adminpanel-right-box">
          <div className="adminpanel-login-title">
            Welcome to HealthSy Subadmin Panel
          </div>
          <div className="adminpanel-right-title">
            <div>Login to access your account</div>
          </div>

          {error && (
            <div style={{ marginBottom: "10px", color: "red" }}>{error}</div>
          )}

          <div className="adminpanel-right-form">
            <div className="adminpanel-right-username">
              <label className="pure-material-textfield-outlined">
                <input
                  className="login-username"
                  style={{ background: "#fff" }}
                  type="text"
                  onChange={(e) => onChangeInput(e, "username")}
                  value={username}
                  placeholder=""
                />
                <span className="adminpanel-placeholder">User Name</span>
              </label>
            </div>
            <p className="text-danger">{nameError}</p>

            <div className="adminpanel-right-password">
              <label className="pure-material-textfield-outlined">
                <input
                  className="login-password"
                  type={showPassword ? "text" : "password"}
                  onChange={(e) => onChangeInput(e, "password")}
                  value={password}
                  placeholder=""
                />
                <span className="adminpanel-input-placeholder">Password</span>
              </label>
            </div>
            <p className="text-danger">{passwordError}</p>

            <div className="adminpanel-right-forgot">
              <div className="check">
                <div className="check-box">
                  <label className="admin-container">
                    <input
                      id="cb1"
                      type="checkbox"
                      checked={rememberMe}
                      onChange={handleRememberMe}
                    />
                    <span className="admin-checkmark"></span>
                  </label>
                </div>
                <div className="adminpanel-loggedIn">Keep me Logged In</div>
              </div>
              <div>Forgot Password?</div>
            </div>

            <div className="adminpanel-right-button">
              <button onClick={handleLogin} style={{ background: loginBtnBg }}>
                Log in
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
